'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = loadScript;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global document */
var scripts = {};

var DEFAULT_LOAD_OPTIONS = {
    reload: false,
    id: false
};

function removeNode(node) {
    if (node && node.parentNode) {
        node.parentNode.removeChild(node);
    }
}

function createHandler(cb, scriptTag) {
    var tag = scriptTag;
    return function () {
        tag.onload = undefined;
        tag.onerror = undefined;
        cb();
    };
}

function loadScript(url) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOAD_OPTIONS,
        id = _ref.id,
        reload = _ref.reload;

    var doc = document;
    if (!scripts[url] || reload) {
        scripts[url] = new _promise2.default(function (resolve, reject) {
            var scriptTag = doc.createElement('script');

            if (id) {
                removeNode(doc.getElementById(id));
                scriptTag.id = id;
            }

            scriptTag.src = url;
            scriptTag.onload = createHandler(resolve, scriptTag);
            scriptTag.onerror = createHandler(reject, scriptTag);

            doc.querySelector('head').appendChild(scriptTag);
        });
    }

    return scripts[url];
}
//# sourceMappingURL=loadScript.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/script-loader/lib/cjs/loadScript.js
 ** module id = 556
 ** module chunks = 1
 **/